<script>
import { services } from '@src/utils/common-services'
import { appConfig } from '@src/app.config'

import { ValidationObserver } from 'vee-validate'

export default {
  components: {
    //  BIconLock,
    // Layout,

    ValidationObserver,
  },
  page: {
    title: 'Create',
    meta: [{ name: 'description', content: `Staff ${appConfig.title}` }],
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    id: {
      default() {
        return null
      },
    },
  },

  data() {
    return {
      firstName: null,
      surname: null,
      phone: null,
      email: null,

      title: null,
      gender: null,
      location: null,
      role: null,
      username: null,
      locationOptions: [
        { id: 1, code: 'GB', label: 'United Kingdom' },
        {
          id: 2,
          code: 'GBS',
          label: 'Scotland',
        },
      ],
      selectOptions: [
        { id: 1, code: 'applying_alone', label: 'Applying Alone' },
        {
          id: 1,
          code: 'applying_with_partner',
          label: 'Applying with partner',
        },
      ],
      genderOptions: [
        { id: 2, code: 'male', label: 'Male' },
        {
          id: 3,
          code: 'female',
          label: 'Female',
        },
        {
          id: 1,
          code: 'others',
          label: 'Others',
        },
      ],
      roleOptions: [{ id: 1, code: null, label: '-Select-' }],
      message: null,
      showSuccess: false,

      trySpin: false,

      validateName: { required: true },
      validatePhone: {
        required: true,
        regex: /^(\+)?[\d]{9,13}$/,
      },
      validateEmail: { email: true },

      preloader: false,
    }
  },
  computed: {
    placeholders() {
      return {
        fname: 'First Name',
        surname: 'Last Name',
        phone: 'Enter phone number',
        email: 'Enter email address',
      }
    },
  },

  watch: {
    classToggle(val, oldVal) {
      if (val !== oldVal) {
        this.scrollToTop()
      }
    },

    menuToggle(val, oldVal) {
      if (val !== oldVal) {
        // console.log(this.menuToggle)
        this.setMenubar({ newVal: true })
        this.$root.$emit('changeMenu', {
          data: true,
        })
      }
    },
    oldPassword: function(val, oldval) {
      if (val !== oldval) {
        this.validateOldPassword = null
        this.validateNewPassword = null
      }
    },
    newPassword: function(val, oldval) {
      if (val !== oldval) {
        this.validateNewPassword = null
        this.validateOldPassword = null
      }
    },
    firstName: function(val, oldval) {
      if (val !== oldval) {
      }
    },
    lastName: function(val, oldval) {
      if (val !== oldval) {
      }
    },

    phone: function(val, oldval) {
      if (val !== oldval) {
      }
    },
  },
  mounted: function() {
    if (this.id !== null) this.getData()
    //  this.$refs.circle.animate(1.0)
    // console.log(state.userDetails)
    // this.profile = services.getCandidatesNameIcon(state.userDetails)
  },
  created() {
    this.getRoles()
  },
  beforeMount() {
    // this.getUser()
    // this.currentProfile = JSON.parse(window.localStorage.getItem('currentUser'))
    // (this.currentUser.type).toUpperCase()
    // this.percentage = 60 // this.currentUser.percentage

    // this.getRoles()

    this.img = null // this.currentUser.avatar
  },
  beforeDestroy() {
    this.$store.commit('jv/clearRecords', { _jv: { type: 'anuser' } })
    this.$store.commit('jv/clearRecords', { _jv: { type: 'role' } })
    this.$store.commit('jv/clearRecords', { _jv: { type: 'user' } })
  },

  methods: {
    getData() {
      this.$store
        .dispatch('jv/get', [
          'anuser',
          {
            url: '/accounts/users/' + this.id + '?include=role,user_profile',
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then((data) => {
          // console.log(data)
          if (data.role._jv !== undefined) this.role = data.role._jv.id
          this.email = data.email
          let userProfile = data.userProfile

          this.firstName = userProfile.firstName
          this.location = userProfile.location
          this.surname = userProfile.surname
          this.phone = userProfile.phoneNumber
          this.gender = userProfile.gender
        })
        .catch((error) => {
          if (error) {
          }
        })
    },

    getRoles() {
      this.$store
        .dispatch('jv/get', [
          'role',
          {
            url: '/accounts/roles',
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then((data) => {
          var check = this.$store.getters['jv/get']('role')
          var id = Object.keys(check)

          for (var i = 0; i < id.length; i++) {
            data = { code: id[i], label: check[id[i]]._jv.attrs.name }
            this.roleOptions.push(data)
            data = null
          }
        })
        .catch((error) => {
          if (error) {
          }
        })
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },

    imageData(data) {
      this.image = data
    },

    sendData() {
      this.trySpin = true

      // console.log(this.currentUser)

      var requestPayload = null
      if (this.id !== null) {
        requestPayload = {
          userProfile: {
            firstName: this.firstName,
            surname: this.surname,
            phoneNumber: this.phone,
            location: this.location,
            gender: this.gender,
          },

          role: this.role,
          email: this.email,

          _jv: {
            type: 'user',
            id: this.id,
          },
        }
        this.$store
          .dispatch('jv/patch', [
            requestPayload,
            {
              url: '/accounts/users/' + this.id,
              headers: services.getHeaderAuthorization(),
            },
          ])
          .then((response) => {
            this.showSuccess = true
            this.$bvToast.show('staffManagement')
            this.message = 'Staff details updated'
            this.trySpin = false
            var parent = this
            setTimeout(() => {
              parent.showSuccess = false
              parent.$bvToast.hide('staffManagement')
              parent.message = null
              parent.$emit('view', true)
            }, 6000)
          })
          .catch((error) => {
            this.showSuccess = false
            if (error.response) {
              for (let err of error.response.data.errors) {
                this.$bvToast.show('staffManagement')
                this.message = err.detail
                this.trySpin = false
              }
            } else {
              this.$bvToast.show('staffManagement')
              this.message = error.message
              this.trySpin = false
            }
            var parent = this
            setTimeout(() => {
              parent.showSuccess = false
              parent.$bvToast.hide('staffManagement')
              parent.message = null
            }, 7000)
          })
      } else {
        requestPayload = {
          userProfile: {
            firstName: this.firstName,
            surname: this.surname,
            phoneNumber: this.phone,
            location: this.location,
            gender: this.gender,
          },
          role: this.role,
          email: this.email,

          _jv: {
            type: 'user',
          },
        }
        this.$store
          .dispatch('jv/post', [
            requestPayload,
            {
              url: '/accounts/users',
              headers: services.getHeaderAuthorization(),
            },
          ])
          .then((response) => {
            this.showSuccess = true
            this.$bvToast.show('staffManagement')
            this.message = 'Created a new staff'
            this.trySpin = false
            var parent = this
            setTimeout(() => {
              parent.showSuccess = false
              parent.$bvToast.hide('staffManagement')
              parent.message = null
              parent.$emit('view', true)
            }, 6000)
          })
          .catch((error) => {
            this.showSuccess = false
            if (error.response) {
              for (let err of error.response.data.errors) {
                this.$bvToast.show('staffManagement')
                this.message = err.detail
                this.trySpin = false
              }
            } else {
              this.$bvToast.show('staffManagement')
              this.message = error.message

              this.trySpin = false
            }
            var parent = this
            setTimeout(() => {
              parent.showSuccess = false
              parent.$bvToast.hide('staffManagement')
              parent.message = null
            }, 6000)
          })
      }
    },
  },
}
</script>

<template>
  <div>
    <div :class="$style.mainWraper">
      <div :class="$style.innerWraper" class="pb30-sm">
        <div :class="$style.profileSettings">
          <div :class="$style.bodyContent">
            <div :class="$style.breadCrumbWraper">
              <h4 class="FL"
                >Staff
                <BIcon
                  :class="$style.actionIcon"
                  class="mr5"
                  icon="chevron-right"
                ></BIcon>
                <span>{{ id !== null ? 'Edit' : 'Create' }}</span>
              </h4>
              <button
                :class="$style.backToBtn"
                class="buttonCommon FR ml15"
                @click="$emit('view', true)"
                ><BIcon icon="eye" class="mr5"></BIcon>View Staff
              </button>
              <div class="clear"></div>
            </div>
            <div class="FR FN-xs mt20-xs"> </div>
            <ValidationObserver ref="settings" v-slot="{ handleSubmit }">
              <form
                :class="$style.form"
                @submit.prevent="handleSubmit(sendData)"
              >
                <div class="clear d-xl-block d-sm-block d-md-none"></div>

                <CommonBaseRadio
                  v-model="location"
                  name="location"
                  label="Location"
                  :more="{ options: locationOptions }"
                  :validation="{ required: true }"
                  @update="location = $event"
                />

                <CommonBaseInputText
                  v-model="firstName"
                  name="firstName"
                  label="First name"
                  :validation="{ required: true }"
                />
                <CommonBaseInputText
                  v-model="surname"
                  name="lastName"
                  label="Last Name"
                  :validation="{ required: true }"
                />
                <CommonBaseSelect
                  v-model="role"
                  name="Role"
                  label="Role"
                  :more="{ options: roleOptions }"
                  :validation="{ required: true }"
                  @update="role = $event"
                />

                <CommonBaseInputText
                  v-model="phone"
                  name="phone"
                  label="Phone"
                  :more="{ placeholder: 'eg:- 01234567891' }"
                  :validation="validatePhone"
                />
                <CommonBaseInputText
                  v-model="email"
                  name="email"
                  label="Email"
                  :validation="{ required: true, email: true }"
                />
                <CommonBaseRadio
                  v-model="gender"
                  name="gender"
                  label="Gender"
                  :more="{ options: genderOptions }"
                  :validation="{ required: true }"
                  @update="gender = $event"
                />
                <div class="clear"></div>

                <div :class="[$style.formGroup]">
                  <div :class="[$style.buttonWrapper]" class=" mt30 mb30">
                    <button
                      class="buttonCommon buttonPrimary button FR"
                      type="submit"
                      v-on="$listeners"
                    >
                      <b-spinner
                        v-if="trySpin"
                        style="width: 18px; height: 18px;"
                        class="ml15 mr15"
                        label="Spinning"
                      ></b-spinner>
                      {{ !trySpin ? (id !== null ? 'Update' : 'Create') : '' }}
                    </button>
                    <div class="clear"></div>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>

    <div :class="$style.toasterMainWrap">
      <b-toast id="staffManagement" solid no-auto-hide>
        <div
          class="d-flex"
          :class="
            !showSuccess
              ? [$style.loginToasterWraper, $style.error]
              : [$style.loginToasterWraper, $style.success]
          "
        >
          <div :class="$style.toasterLeft">
            <BIcon
              icon="chat-square-dots-fill"
              :class="$style.toasterIcon"
            ></BIcon>
          </div>
          <div :class="$style.toasterRight">
            <strong class="mr-auto" :class="$style.toasterHeader"
              >Notice!</strong
            >
            <p :class="$style.toasterContent">{{ message }}</p>
          </div>
          <div class="clear"></div>
        </div>
      </b-toast>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';

.form {
  padding: 20px 30px;
}
.formGroup {
  max-width: 500px;
}

.backToBtn {
  padding: 5px 14px !important;
  font-family: 'ProductSansRegular', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 15px !important;
  color: #fff !important;
  background: #ff5d16 !important;
  border-radius: 50px !important;
}

// breadcrumb
.breadCrumbWraper {
  padding: 15px 30px;
  border-bottom: 2px solid #f8f9f9;

  h4 {
    margin: 0;
    font-family: 'SourceSansProSemibold', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 25px;
    line-height: 29px;
    color: #455d73;
  }
  span {
    font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    font-weight: 600;
    line-height: 29px;
    color: #8c959f;
  }

  svg {
    font-size: 16px;
  }
}
// breadcrumb

.profileSettings {
  float: left;
  width: 100%;
}

// Page Title - Info text
.bodyContent {
  float: left;
  width: 100%;
}
// Page Title - Info text

.mainWraper {
  width: 100%;
  min-height: calc(100vh - 55px);
  padding: 15px;
}

.innerWraper {
  position: relative;
  display: flex;
  min-height: calc(100vh - 85px);
  overflow: hidden;
  background: $color-body-inner-background;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.03);
}

@media (max-width: 767px) {
  .mainWraper {
    padding: 0 !important;
  }
  .breadCrumbWraper {
    h4 {
      font-size: 20px;
      line-height: 24px;
    }
    span {
      font-size: 18px;
      line-height: 24px;
    }
  }
  .profileSettings {
    padding: 0;
  }
}
</style>
